export default __webpack_public_path__ + "static/media/Approved.0bc3d814.svg";